import { ReactElement, memo } from "react";

import { Toast } from "@sabre/spark-react-core";
import { ToastType } from "@sabre/spark-react-core/types";

import { useAppNotification } from "@context/AppNotification";

const ToasterUnMemoized = (): ReactElement => {
  const { notification, setNotification } = useAppNotification();

  return (
    <Toast
      open={Boolean(notification)}
      onClose={() => setNotification(null)}
      type={notification?.type}
      title={notification?.title || ""}
      details={notification?.description}
      icon={notification?.type === ToastType.POSITIVE ? "spark-icon-check" : "spark-icon-alert-triangle"}
      actionIcon={"spark-icon-close"}
      actionLabel={"close"}
      duration={notification?.duration || 4}
      el={notification?.containerElement || document.querySelector(".spark-header__nav")}
      elHeader={notification?.containerElement ? undefined : document.querySelector(".spark-header__nav")}
    />
  );
};

export const Toaster = memo(ToasterUnMemoized);
